import { motion, useInView, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect, useRef } from "react";
import { STATS } from "@/lib/data";

function Counter({ to }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const count = useMotionValue(0);
  const rounded = useTransform(count, (v) => Math.round(v));

  useEffect(() => {
    if (inView) {
      const controls = animate(count, Number(to), { duration: 1.8, ease: [0.22, 1, 0.36, 1] });
      return controls.stop;
    }
  }, [inView, to, count]);

  return <motion.span ref={ref}>{rounded}</motion.span>;
}

export default function StatsBand() {
  return (
    <section data-testid="stats-band" className="relative bg-[#050505] border-y border-white/10">
      <div className="w-full max-w-[1440px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6">
          {STATS.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="relative"
            >
              <div className="flex items-start">
                <div className="font-impact text-white text-6xl md:text-8xl leading-none flex items-baseline">
                  {s.prefix && <span className="text-[#3FE1D1]">{s.prefix}</span>}
                  <Counter to={s.value} />
                  <span className="text-[#3FE1D1] ml-1">{s.suffix}</span>
                </div>
              </div>
              <p className="mt-3 text-white/55 text-sm md:text-base leading-snug max-w-[220px]">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
